import { Injectable } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { UserInfo } from '../models/UserInfo';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constants } from '../constants/constants';
import { ToasterNotificationService } from '../services/toaster-notification.service';
import { CommonDataService } from './common-data.service';
import { CostReviewParameters } from '../models/CostReviewParameters';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as logoData from '../assets/SiemensLogoBase64.json';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { ExportObjectAsFieldValuePDFOptions } from '../models/ExportObjectAsFieldValuePDFOptions';
import { ExportTablesToPDFOptions } from '../models/ExportTableToPDF'
import { CostReviewAttributes } from '../models/CostReviewAttributes';
import { CostReviewFireEnUsAttributes } from '../models/CostReviewFireEnUsAttributes';
import { CostReviewSecurityEnUsAttributes } from '../models/CostReviewSecurityEnUsAttributes';
import { CostReviewDatabaseRecord } from '../models/CostReviewDatabaseRecord';


// Define the ActiveTabInfo interface
export interface ActiveTabInfo {
  tabName: string;
  tabComponentInstance: any;
  isSA: boolean;
}

@Injectable({
  providedIn: 'root'
})

export class CommonFunctionsService {
  CostReviewParameters: CostReviewParameters[] = [];
  siemensLogoBase64: string = logoData.siemensLogoBase64;
  redFlagBase64: string = logoData.redFlagBase64;
  constructor(private commonDataService: CommonDataService,
    private spinner: NgxSpinnerService,
    private clipboard: Clipboard,
    private toasterService: ToasterNotificationService,
    private translate: TranslateService
  ) {

  }


  startSpinner(spinnerName: string = '') {
    if (spinnerName == '') {
      this.spinner.show('dashboardSpinner');
    }
    else {
      this.spinner.show(spinnerName)
    }
  }

  stopSpinner(spinnerName: string = '') {
    if (spinnerName == '') {
      this.spinner.hide('dashboardSpinner');
    }
    else {
      this.spinner.hide(spinnerName)
    }
  }


  getIdTokens() {
    let tokenKey: string | null = null;
    const keys = Object.keys(localStorage);
    for (const str of keys) {
      if (str.includes("idtoken")) {
        tokenKey = str;
      }
    }
    if (!tokenKey) {
      return null;
    }
    const jsonString = localStorage.getItem(tokenKey)?.toString();
    const jsonObject = jsonString ? JSON.parse(jsonString) : null;
    if (jsonObject != null) {
      return (jsonObject.secret).toString();
    }
  }

  AssignTokenValueToUserInfo() {
    const token = localStorage.getItem(Constants.MT_TOKEN_KEY);
    let userInfo: UserInfo = new UserInfo();
    if (token) {
      const tokenDetails = JSON.parse(atob(token.split('.')[1])) as any;
      userInfo = {
        gId: tokenDetails.GId,
        fullName: tokenDetails.UserName,
        email: tokenDetails.EmailID,
        roleId: Number(tokenDetails.UserRole),
        // isReviewer: tokenDetails.IsReviewer || false
        isReviewer: (tokenDetails.IsReviewer === 'true' || tokenDetails.IsReviewer === 'True'),
        accessLevel: Number(tokenDetails.AccessLevel),
        countryCode: tokenDetails.CountryCode,
        locale: tokenDetails.Locale || Constants.DEFAULT_LOCALE
      }
      this.commonDataService.setUserInfo(userInfo);
    }

    // return userInfo
  }
  appendSymbolToText(text: string, symbol: string) {
    switch (symbol) {
      case '$':
        return symbol + parseFloat(text).toFixed(2);
      case '%':
        return parseFloat(text).toFixed(2) + symbol;
      default:
        return text;
    }
  }

  appendSymboltoCommaSeparatedNumber(value: string, symbol: string): string {
    switch (symbol) {
      case '$':
        return symbol + value;
      case '%':
        return value + symbol;
      default:
        return value;
    }
  }

  businessTypePresent(business: string, data: CostReviewDatabaseRecord): CostReviewAttributes | CostReviewFireEnUsAttributes | CostReviewSecurityEnUsAttributes | undefined {
    switch (business) {
      case 'F':
        return JSON.parse(JSON.stringify(data));
      case 'S':
        return JSON.parse(JSON.stringify(data));
      case 'A':
      case 'E':
      case 'M':
        return JSON.parse(JSON.stringify(data));
      default:
        return undefined;
    }

  }


  getYearRangetillCurrentYearfromYear(tillYear: number): number[] {
    const currentYear = new Date().getFullYear();
    let dateRangeYears = [];
    for (let year = currentYear; year >= tillYear; year--) {
      dateRangeYears.push(year);
    }

    return dateRangeYears;
  }

  formatToTwoDecimal(value: number | string): string {
    let numericValue: number;
    if (typeof value === 'string') {
      numericValue = parseFloat(value);
    } else {
      numericValue = value;
    }
    return isNaN(numericValue) ? Constants.NA : (numericValue === Constants.ZERO ? Constants.ZERO_DECIMAL : numericValue.toFixed(Constants.TWO));
  }


  copyRowToClipboard(copiedRows: any): void {

    if (!copiedRows || !copiedRows.length) {
      this.toasterService.showInfo(
        this.translate.instant('NOTIFICATIONS_MESSAGES.COPY_ROWS'), 
        this.translate.instant('NOTIFICATIONS_MESSAGES.NO_DATA_TO_COPY')
      );
      return;
    }
    else {

      const rows = copiedRows.map((row: any) =>
        Object.values(row)
          .map((value) => String(value ?? Constants.EMPTY_STRING).replace(/\t/g, Constants.DOUBLE_EMPTY_SPACE))
          .join('\t')
      )

      const clipboardData = rows.join('\n');
      this.clipboard.copy(clipboardData);
      this.toasterService.showSuccess(
        this.translate.instant('NOTIFICATIONS_MESSAGES.COPY_ROWS'), 
        this.translate.instant('NOTIFICATIONS_MESSAGES.ESTIMATE_ROWS_COPY_SUCCESS_MSG')
      );
    }

  }

  transformRow(row: Record<string, any>): Record<string, any> {
    const result: Record<string, any> = {};
    for (const key in row) {
      const trimmedLowerKey = key.trim().toLowerCase();
      result[trimmedLowerKey] = row[key];
    }
    return result;
  }

  exportTablesToPDF(options: ExportTablesToPDFOptions) {
  const {
    tables,
    fileName = 'export.pdf',
    hasNotes = false,
    estimateID = Constants.EMPTY_STRING,
    estimateName = Constants.EMPTY_STRING,
    tabName = Constants.EMPTY_STRING
  } = options;

  let doc;
  if (hasNotes) {
    doc = new jsPDF({ orientation: 'landscape', format: 'tabloid' });
  } else {
    doc = new jsPDF({ orientation: 'landscape' });
  }

  const headerHeight = Constants.EIGHTY;
  let startY = headerHeight + Constants.TEN;

 tables.forEach(table => {
      let body: any[] = [];
      let theme: 'plain' | 'grid' = 'grid';
      let columnStyles = table.columnStyles;

      switch (true) {
        case !table.data || table.data.length === Constants.ZERO: {
          body = [[{
        content: this.translate?.instant?.('COMMON_LABELS.NO_DATA_FOUND'),
        colSpan: table.displayedColumns.length,
        styles: {
          halign: 'center',
          fontStyle: 'normal',
          fontSize: Constants.ELEVEN,
          textColor: [Constants.ZERO, Constants.ZERO, Constants.ZERO],
          lineWidth: Constants.ZERO,
          fillColor: [Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE]
        }
          }]];
          theme = 'plain';
          columnStyles = {};
          break;
        }
        case table.data.length === Constants.ONE: {
          const nonEmptyKeys = Object.entries(table.data[0]).filter(([_, v]) => v !== undefined && v !== null && v !== Constants.EMPTY_STRING);
          if (nonEmptyKeys.length === Constants.ONE) {
        body = [[{
          content: nonEmptyKeys[0][1],
          colSpan: table.displayedColumns.length,
          styles: {
            halign: 'center',
            fontStyle: 'normal',
            fontSize: Constants.ELEVEN,
            textColor: [Constants.ZERO, Constants.ZERO, Constants.ZERO],
            lineWidth: Constants.ZERO,
            fillColor: [Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE]
          }
        }]];
        theme = 'plain';
        columnStyles = {};
          } else {
        body = table.data.map(row =>
          table.displayedColumns.map(col => {
            let value = table.typeGuard ? table.typeGuard(row, col) : row[col];
            if (hasNotes && col.toLowerCase() === 'notes') {
          value = this.breakLongWords(value, Constants.TWENTY);
            }
            return value;
          })
        );
          }
          break;
        }
        default: {
          body = table.data.map(row =>
        table.displayedColumns.map(col => {
          let value = table.typeGuard ? table.typeGuard(row, col) : row[col];
          if (hasNotes && col.toLowerCase() === 'notes') {
            value = this.breakLongWords(value, Constants.TWENTY);
          }
          return value;
        })
          );
        }
      }
      autoTable(doc, {
        startY,
        head: [table.displayedColumns.map(col => table.headers[col] || col)],
        body: body,
        theme: theme,
        headStyles: { fillColor: Constants.GREEN_COLOR, textColor: [Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE] },
        styles: { fontSize: Constants.NINE, font: 'helvetica' },
        columnStyles: table.columnStyles || {},
        margin: { top: headerHeight, bottom: Constants.THIRTY },
        didParseCell: function (data) {
          if (typeof data.cell.raw === 'string' && data.cell.raw.includes('[[ASTRIX]]')) {
            data.cell.text = [data.cell.raw.replace('[[ASTRIX]]', Constants.EMPTY_STRING).trim()];
          }
        },
        didDrawCell: function (this: CommonFunctionsService, data: any) {
          const isNoData =
            typeof data.cell.raw === 'string' &&
            (data.cell.raw === this.translate?.instant?.('No data found') || data.cell.raw === 'No data found');

          const isSingleValueRow =
            data.row && data.row.raw && Array.isArray(data.row.raw) &&
            data.row.raw.length === 1 &&
            data.cell.colSpan === data.table.columns.length;

          if (isNoData || isSingleValueRow) {
            const doc = data.doc;
            doc.setDrawColor(Constants.ONE_FIFTY, Constants.ONE_FIFTY, Constants.ONE_FIFTY);
            doc.setLineWidth(Constants.ZERO_POINT_ONE);
            doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height);
          }

          if (typeof data.cell.raw === 'string' && data.cell.raw.includes('[[ASTRIX]]')) {
            const text = data.cell.raw.replace('[[ASTRIX]]', Constants.EMPTY_STRING).trim();
            data.cell.text = [text];
            const doc = data.doc;
            const textWidth = doc.getTextWidth(text);
            const x = data.cell.x + textWidth + Constants.TWO;
            const y = data.cell.y + Constants.ONE;
            const flagWidth = Constants.FOUR;
            const flagHeight = Constants.FOUR;
            if (typeof this.redFlagBase64 !== 'undefined') {
              doc.addImage(this.redFlagBase64, 'PNG', x, y, flagWidth, flagHeight);
            }
          }
        }.bind(this),
        didDrawPage: (data) => {
          const pageWidth = doc.internal.pageSize.getWidth();
          const logoBase64 = this.siemensLogoBase64;
          if (logoBase64) {
            const imgProps = doc.getImageProperties(logoBase64);
            const logoWidth = Constants.TWENTY_FIVE;
            const logoHeight = (imgProps.height * Constants.TWENTY) / imgProps.width;
            doc.addImage(logoBase64, 'PNG', Constants.FOURTEEN, Constants.TEN, logoWidth, logoHeight);
          }
          if (tabName) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(Constants.TWENTY);
            doc.setTextColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);
            const textWidth = doc.getTextWidth(tabName);
            doc.text(tabName, (pageWidth - textWidth) / Constants.TWO, Constants.THIRTY);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);

            const lineY = Constants.THIRTY_FIVE;
            doc.setLineWidth(Constants.ZERO_POINT_SEVEN);
            doc.setDrawColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);
            doc.line(Constants.FOURTEEN, lineY, pageWidth - Constants.FOURTEEN, lineY);

            const pointsStartY = Constants.FORTY_SEVEN;
            doc.setFontSize(Constants.TWELVE);

            const label1 = this.translate.instant('ESTIMATES_TAB.ESTIMATE_ID');
            const label2 = this.translate.instant('COMMON_LABELS.ESTIMATE_NAME');
            const labelWidth = Math.max(doc.getTextWidth(label1), doc.getTextWidth(label2));
            const dataStartX = Constants.TWENTY_FOUR + labelWidth + Constants.TWO;

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(Constants.ELEVEN);
            doc.text(label1, Constants.FOURTEEN, pointsStartY);
            doc.text(String(estimateID ?? Constants.EMPTY_STRING), dataStartX, pointsStartY);


            doc.setFont('helvetica', 'bold');
            doc.setFontSize(Constants.ELEVEN);
            doc.text(label2, Constants.FOURTEEN, pointsStartY + Constants.EIGHT);
            doc.text(String(estimateName ?? Constants.EMPTY_STRING), dataStartX, pointsStartY + Constants.EIGHT);

            const afterEstimateLineY = Constants.SIXTY_SEVEN;
            doc.setLineWidth(Constants.ZERO_POINT_SEVEN);
            doc.setDrawColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);
            doc.line(Constants.FOURTEEN, afterEstimateLineY, pageWidth - Constants.FOURTEEN, afterEstimateLineY);
          }
        },
      });
      startY = (doc as any).lastAutoTable.finalY + Constants.TEN;
    });

   // --- Footer Section ---
    const pageCount = doc.getNumberOfPages();
    for (let i = Constants.ONE; i <= pageCount; i++) {
      doc.setPage(i);
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      doc.setFontSize(Constants.NINE);
      doc.setTextColor(Constants.ZERO, Constants.ZERO, Constants.ZERO);

      // Left bottom: Confidential
      doc.text(this.translate.instant('COMMON_LABELS.CONFIDENTIAL'), Constants.FOURTEEN, pageHeight - Constants.TEN);
      // Center bottom: Company name
      const companyTextWidth = doc.getTextWidth('Siemens Industry, Inc.');
      doc.text('Siemens Industry, Inc.', (pageWidth - companyTextWidth) / Constants.TWO, pageHeight - Constants.TEN);

      // Right bottom: Page number
      const pageNoText = `${this.translate.instant('COMMON_LABELS.PAGE')} ${i} ${this.translate.instant('COMMON_LABELS.OF')} ${pageCount}`;
      const pageNoWidth = doc.getTextWidth(pageNoText);
      doc.text(pageNoText, pageWidth - pageNoWidth - Constants.FOURTEEN, pageHeight - Constants.TEN);
    }

    doc.save(estimateID + '_' + fileName);
}


  // exportTablesToPDF(
  //   tables: {
  //     title: string,
  //     displayedColumns: string[],
  //     headers: { [key: string]: string },
  //     data: any[],
  //     typeGuard?: (row: any, col: string) => any,
  //     columnStyles?: { [key: string]: any }
  //   }[],
  //   fileName = 'export.pdf',
  //   hasNotes: boolean = false,
  //   estimateID: string = Constants.EMPTY_STRING,
  //   estimateName: string = Constants.EMPTY_STRING,
  //   tabName: string = Constants.EMPTY_STRING
  // ) {

  //   let doc;
  //   if (hasNotes) {
  //     doc = new jsPDF({ orientation: 'landscape', format: 'tabloid' });
  //   } else {
  //     doc = new jsPDF({ orientation: 'landscape' });
  //   }

  //   const headerHeight = Constants.EIGHTY;
  //   let startY = headerHeight + Constants.TEN;

  //   tables.forEach(table => {
  //     let body: any[] = [];
  //     let theme: 'plain' | 'grid' = 'grid';
  //     let columnStyles = table.columnStyles;

  //     switch (true) {
  //       case !table.data || table.data.length === Constants.ZERO: {
  //         body = [[{
  //       content: this.translate?.instant?.('COMMON_LABELS.NO_DATA_FOUND'),
  //       colSpan: table.displayedColumns.length,
  //       styles: {
  //         halign: 'center',
  //         fontStyle: 'normal',
  //         fontSize: Constants.ELEVEN,
  //         textColor: [Constants.ZERO, Constants.ZERO, Constants.ZERO],
  //         lineWidth: Constants.ZERO,
  //         fillColor: [Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE]
  //       }
  //         }]];
  //         theme = 'plain';
  //         columnStyles = {};
  //         break;
  //       }
  //       case table.data.length === Constants.ONE: {
  //         const nonEmptyKeys = Object.entries(table.data[0]).filter(([_, v]) => v !== undefined && v !== null && v !== Constants.EMPTY_STRING);
  //         if (nonEmptyKeys.length === Constants.ONE) {
  //       body = [[{
  //         content: nonEmptyKeys[0][1],
  //         colSpan: table.displayedColumns.length,
  //         styles: {
  //           halign: 'center',
  //           fontStyle: 'normal',
  //           fontSize: Constants.ELEVEN,
  //           textColor: [Constants.ZERO, Constants.ZERO, Constants.ZERO],
  //           lineWidth: Constants.ZERO,
  //           fillColor: [Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE]
  //         }
  //       }]];
  //       theme = 'plain';
  //       columnStyles = {};
  //         } else {
  //       body = table.data.map(row =>
  //         table.displayedColumns.map(col => {
  //           let value = table.typeGuard ? table.typeGuard(row, col) : row[col];
  //           if (hasNotes && col.toLowerCase() === 'notes') {
  //         value = this.breakLongWords(value, Constants.TWENTY);
  //           }
  //           return value;
  //         })
  //       );
  //         }
  //         break;
  //       }
  //       default: {
  //         body = table.data.map(row =>
  //       table.displayedColumns.map(col => {
  //         let value = table.typeGuard ? table.typeGuard(row, col) : row[col];
  //         if (hasNotes && col.toLowerCase() === 'notes') {
  //           value = this.breakLongWords(value, Constants.TWENTY);
  //         }
  //         return value;
  //       })
  //         );
  //       }
  //     }
  //     autoTable(doc, {
  //       startY,
  //       head: [table.displayedColumns.map(col => table.headers[col] || col)],
  //       body: body,
  //       theme: theme,
  //       headStyles: { fillColor: Constants.GREEN_COLOR, textColor: [Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE, Constants.TWO_FIFTY_FIVE] },
  //       styles: { fontSize: Constants.NINE, font: 'helvetica' },
  //       columnStyles: table.columnStyles || {},
  //       margin: { top: headerHeight, bottom: Constants.THIRTY },
  //       didParseCell: function (data) {
  //         if (typeof data.cell.raw === 'string' && data.cell.raw.includes('[[ASTRIX]]')) {
  //           data.cell.text = [data.cell.raw.replace('[[ASTRIX]]', Constants.EMPTY_STRING).trim()];
  //         }
  //       },
  //       didDrawCell: function (this: CommonFunctionsService, data: any) {
  //         const isNoData =
  //           typeof data.cell.raw === 'string' &&
  //           (data.cell.raw === this.translate?.instant?.('No data found') || data.cell.raw === 'No data found');

  //         const isSingleValueRow =
  //           data.row && data.row.raw && Array.isArray(data.row.raw) &&
  //           data.row.raw.length === 1 &&
  //           data.cell.colSpan === data.table.columns.length;

  //         if (isNoData || isSingleValueRow) {
  //           const doc = data.doc;
  //           doc.setDrawColor(Constants.ONE_FIFTY, Constants.ONE_FIFTY, Constants.ONE_FIFTY);
  //           doc.setLineWidth(Constants.ZERO_POINT_ONE);
  //           doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height);
  //         }

  //         if (typeof data.cell.raw === 'string' && data.cell.raw.includes('[[ASTRIX]]')) {
  //           const text = data.cell.raw.replace('[[ASTRIX]]', Constants.EMPTY_STRING).trim();
  //           data.cell.text = [text];
  //           const doc = data.doc;
  //           const textWidth = doc.getTextWidth(text);
  //           const x = data.cell.x + textWidth + Constants.TWO;
  //           const y = data.cell.y + Constants.ONE;
  //           const flagWidth = Constants.FOUR;
  //           const flagHeight = Constants.FOUR;
  //           if (typeof this.redFlagBase64 !== 'undefined') {
  //             doc.addImage(this.redFlagBase64, 'PNG', x, y, flagWidth, flagHeight);
  //           }
  //         }
  //       }.bind(this),
  //       didDrawPage: (data) => {
  //         const pageWidth = doc.internal.pageSize.getWidth();
  //         const logoBase64 = this.siemensLogoBase64;
  //         if (logoBase64) {
  //           const imgProps = doc.getImageProperties(logoBase64);
  //           const logoWidth = Constants.TWENTY_FIVE;
  //           const logoHeight = (imgProps.height * Constants.TWENTY) / imgProps.width;
  //           doc.addImage(logoBase64, 'PNG', Constants.FOURTEEN, Constants.TEN, logoWidth, logoHeight);
  //         }
  //         if (tabName) {
  //           doc.setFont('helvetica', 'bold');
  //           doc.setFontSize(Constants.TWENTY);
  //           doc.setTextColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);
  //           const textWidth = doc.getTextWidth(tabName);
  //           doc.text(tabName, (pageWidth - textWidth) / Constants.TWO, Constants.THIRTY);
  //           doc.setFont('helvetica', 'normal');
  //           doc.setTextColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);

  //           const lineY = Constants.THIRTY_FIVE;
  //           doc.setLineWidth(Constants.ZERO_POINT_SEVEN);
  //           doc.setDrawColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);
  //           doc.line(Constants.FOURTEEN, lineY, pageWidth - Constants.FOURTEEN, lineY);

  //           const pointsStartY = Constants.FORTY_SEVEN;
  //           doc.setFontSize(Constants.TWELVE);

  //           const label1 = this.translate.instant('ESTIMATES_TAB.ESTIMATE_ID');
  //           const label2 = this.translate.instant('COMMON_LABELS.ESTIMATE_NAME');
  //           const labelWidth = Math.max(doc.getTextWidth(label1), doc.getTextWidth(label2));
  //           const dataStartX = Constants.TWENTY_FOUR + labelWidth + Constants.TWO;

  //           doc.setFont('helvetica', 'bold');
  //           doc.setFontSize(Constants.ELEVEN);
  //           doc.text(label1, Constants.FOURTEEN, pointsStartY);
  //           doc.text(String(estimateID ?? Constants.EMPTY_STRING), dataStartX, pointsStartY);


  //           doc.setFont('helvetica', 'bold');
  //           doc.setFontSize(Constants.ELEVEN);
  //           doc.text(label2, Constants.FOURTEEN, pointsStartY + Constants.EIGHT);
  //           doc.text(String(estimateName ?? Constants.EMPTY_STRING), dataStartX, pointsStartY + Constants.EIGHT);

  //           const afterEstimateLineY = Constants.SIXTY_SEVEN;
  //           doc.setLineWidth(Constants.ZERO_POINT_SEVEN);
  //           doc.setDrawColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);
  //           doc.line(Constants.FOURTEEN, afterEstimateLineY, pageWidth - Constants.FOURTEEN, afterEstimateLineY);
  //         }
  //       },
  //     });
  //     startY = (doc as any).lastAutoTable.finalY + Constants.TEN;
  //   });

  //   // --- Footer Section ---
  //   const pageCount = doc.getNumberOfPages();
  //   for (let i = Constants.ONE; i <= pageCount; i++) {
  //     doc.setPage(i);
  //     const pageWidth = doc.internal.pageSize.getWidth();
  //     const pageHeight = doc.internal.pageSize.getHeight();
  //     doc.setFontSize(Constants.NINE);
  //     doc.setTextColor(Constants.ZERO, Constants.ZERO, Constants.ZERO);

  //     // Left bottom: Confidential
  //     doc.text(this.translate.instant('COMMON_LABELS.CONFIDENTIAL'), Constants.FOURTEEN, pageHeight - Constants.TEN);
  //     // Center bottom: Company name
  //     const companyTextWidth = doc.getTextWidth('Siemens Industry, Inc.');
  //     doc.text('Siemens Industry, Inc.', (pageWidth - companyTextWidth) / Constants.TWO, pageHeight - Constants.TEN);

  //     // Right bottom: Page number
  //     const pageNoText = `${this.translate.instant('COMMON_LABELS.PAGE')} ${i} ${this.translate.instant('COMMON_LABELS.OF')} ${pageCount}`;
  //     const pageNoWidth = doc.getTextWidth(pageNoText);
  //     doc.text(pageNoText, pageWidth - pageNoWidth - Constants.FOURTEEN, pageHeight - Constants.TEN);
  //   }

  //   doc.save(estimateID + '_' + fileName);
  // }

  breakLongWords(text: string, maxLen: number = 50): string {
    if (!text) return '';
    return text.split(' ').map(word => {
      if (word.length > maxLen) {
        const parts: string[] = [];
        for (let i = 0; i < word.length; i += maxLen) {
          parts.push(word.substring(i, i + maxLen));
        }
        return parts.join(' ');
      }
      return word;
    }).join(' ');
  }

  exportObjectAsFieldValuePDF(options: ExportObjectAsFieldValuePDFOptions) {
    const { data, fileName = 'export.pdf', doc: externalDoc, tabName, estimateID, estimateName } = options;

    const doc = externalDoc || new jsPDF({ orientation: 'landscape' });

    const headerHeight = Constants.EIGHTY;
    let startY = headerHeight + Constants.TEN;
    const logoBase64 = this.siemensLogoBase64;

    let headers: string[] = [Constants.EMPTY_STRING, Constants.EMPTY_STRING];
    let body: any[] = [];

    if (typeof data === 'string') {
      body = [[{
        content: data,
        colSpan: Constants.TWO,
        styles: {
          halign: 'center',
          fontStyle: 'bold',
          fontSize: Constants.ELEVEN,
          textColor: [Constants.ONE_FIFTY, Constants.ONE_FIFTY, Constants.ONE_FIFTY]
        }
      }]];
    }
    else {
      const dataEntries = Object.entries(data);
      if (dataEntries.length > Constants.ZERO) {
        body = dataEntries.map(([field, value]) => [
          field,
          typeof value === 'string' ? this.breakLongWords(value) : value
        ]);
      } else {
        body = [[{
          content: this.translate?.instant?.('REVIEW_SOL_MARGINS_TAB.MARGINS_DATA_NOT_FOUND') || 'No data found',
          colSpan: Constants.TWO,
          styles: {
            halign: 'center',
            fontStyle: 'bold',
            fontSize: Constants.ELEVEN,
            textColor: [Constants.ONE_FIFTY, Constants.ONE_FIFTY, Constants.ONE_FIFTY]
          }
        }]];
      }

      autoTable(doc, {
        startY,
        head: [headers],
        body: body,
        theme: 'grid',
        headStyles: {
          fillColor: [Constants.ZERO, Constants.ONE_FIFTY_THREE, Constants.ONE_FIFTY_THREE],
          font: 'helvetica',
          fontSize: Constants.ELEVEN,
        },
        styles: { font: 'helvetica', fontSize: Constants.NINE },
        margin: { top: headerHeight, bottom: Constants.THIRTY },
        didParseCell: function (data) {
          if (data.section === 'head' && (data.column.index === Constants.ZERO || data.column.index === Constants.ONE)) {
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.fontSize = Constants.ELEVEN;
          }
          if (typeof data.cell.raw === 'string' && data.cell.raw.includes('[[ASTRIX]]')) {
            data.cell.text = [data.cell.raw.replace('[[ASTRIX]]', Constants.EMPTY_STRING).trim()];
          }
        },
        didDrawCell: function (data) {
          if (typeof data.cell.raw === 'string' && data.cell.raw.includes('[[ASTRIX]]')) {
            const text = data.cell.raw.replace('[[ASTRIX]]', Constants.EMPTY_STRING).trim();
            data.cell.text = [text];
            const doc = data.doc;
            const textWidth = doc.getTextWidth(text);
            const x = data.cell.x + textWidth + Constants.TWO;
            const y = data.cell.y + Constants.TWO;
            doc.setTextColor(Constants.TWO_FIFTY_FIVE, Constants.ZERO, Constants.ZERO);

            doc.setFontSize(Constants.TWELVE);
            doc.text('*', x, y, { baseline: 'top' });

            doc.setFontSize(Constants.TWELVE);
            doc.setTextColor(Constants.ZERO, Constants.ZERO, Constants.ZERO);
          }
        },
        didDrawPage: (data) => {
          const pageWidth = doc.internal.pageSize.getWidth();
          const logoBase64 = this.siemensLogoBase64;
          if (logoBase64) {
            const imgProps = doc.getImageProperties(logoBase64);
            const logoWidth = Constants.TWENTY_FIVE;
            const logoHeight = (imgProps.height * Constants.TWENTY) / imgProps.width;
            doc.addImage(logoBase64, 'PNG', Constants.FOURTEEN, Constants.TEN, logoWidth, logoHeight);
          }
          if (tabName) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(Constants.TWENTY);
            doc.setTextColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);
            const textWidth = doc.getTextWidth(tabName);
            doc.text(tabName, (pageWidth - textWidth) / Constants.TWO, Constants.THIRTY);
            doc.setFont('helvetica', 'normal');
            doc.setTextColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);

            const lineY = Constants.THIRTY_FIVE;
            doc.setLineWidth(Constants.ZERO_POINT_SEVEN);
            doc.setDrawColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);
            doc.line(Constants.FOURTEEN, lineY, pageWidth - Constants.FOURTEEN, lineY);

            const pointsStartY = Constants.FORTY_SEVEN;
            doc.setFontSize(Constants.TEN);

            const label1 = this.translate.instant('ESTIMATES_TAB.ESTIMATE_ID');
            const label2 = this.translate.instant('COMMON_LABELS.ESTIMATE_NAME');
            const labelWidth = Math.max(doc.getTextWidth(label1), doc.getTextWidth(label2));
            const dataStartX = Constants.TWENTY_FOUR + labelWidth + Constants.TWO;

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(Constants.ELEVEN);
            doc.text(label1, Constants.FOURTEEN, pointsStartY);
            doc.text(String(estimateID ?? Constants.EMPTY_STRING), dataStartX, pointsStartY);

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(Constants.ELEVEN);
            doc.text(label2, Constants.FOURTEEN, pointsStartY + Constants.EIGHT);
            doc.text(String(estimateName ?? Constants.EMPTY_STRING), dataStartX, pointsStartY + Constants.EIGHT);

            const afterEstimateLineY = Constants.SIXTY_SEVEN;
            doc.setLineWidth(Constants.ZERO_POINT_SEVEN);
            doc.setDrawColor(Constants.ZERO, Constants.SIXTY_FOUR, Constants.ONE_TWENTY_EIGHT);
            doc.line(Constants.FOURTEEN, afterEstimateLineY, pageWidth - Constants.FOURTEEN, afterEstimateLineY);
          }
        },
      });
      // --- Footer Section ---
      const pageCount = doc.getNumberOfPages();
      for (let i = Constants.ONE; i <= pageCount; i++) {
        doc.setPage(i);
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        doc.setFontSize(Constants.NINE);
        doc.setTextColor(Constants.ZERO, Constants.ZERO, Constants.ZERO);

        doc.text(this.translate.instant('COMMON_LABELS.CONFIDENTIAL'), Constants.FOURTEEN, pageHeight - Constants.TEN);

        const companyTextWidth = doc.getTextWidth('Siemens Industry, Inc.');
        doc.text('Siemens Industry, Inc.', (pageWidth - companyTextWidth) / Constants.TWO, pageHeight - Constants.TEN);

        const pageNoText = `${this.translate.instant('COMMON_LABELS.PAGE')} ${i} ${this.translate.instant('COMMON_LABELS.OF')} ${pageCount}`;
        const pageNoWidth = doc.getTextWidth(pageNoText);
        doc.text(pageNoText, pageWidth - pageNoWidth - Constants.FOURTEEN, pageHeight - Constants.TEN);

        doc.setTextColor(Constants.ZERO, Constants.ZERO, Constants.ZERO);
      }
      if (!externalDoc) {
        doc.save((estimateID || Constants.EMPTY_STRING) + '_' + fileName);
      }
    }
  }

  toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, (txt) =>
      txt.charAt(Constants.ZERO).toUpperCase() + txt.substr(Constants.ONE).toLowerCase()
    );
  }

  toNumberArray(values: Array<string | number> | undefined, options: string[]): number[] {
    if (!Array.isArray(values)) {
      return [];
    }
 
    return values
      .map((value) => {
        const optionIndex = options.findIndex((option) => option.toString() === value.toString());
        if (optionIndex >= 0) {
          return optionIndex + 1;
        }
 
        // Backward compatibility when values are already stored as numeric indexes.
        const numericValue = Number(value);
        if (Number.isInteger(numericValue) && numericValue >= 1 && numericValue <= options.length) {
          return numericValue;
        }
 
        return NaN;
      })
      .filter((value) => !Number.isNaN(value));
  }

  formControlsValueForString(formGroup: FormGroup | undefined, formControlName: string): string {
    const controlValue = formGroup?.controls[formControlName]?.value;
    return controlValue || Constants.EMPTY_STRING;
  }

  isValueEqualToTranslation(value: string | null | undefined, translationKey: string): boolean {
    return !!value && value === this.translate.instant(translationKey);
  }

  isControlValueEqualToTranslation(formGroup: FormGroup | undefined, formControlName: string, translationKey: string): boolean {
    const controlValue = this.formControlsValueForString(formGroup, formControlName);
    return this.isValueEqualToTranslation(controlValue, translationKey);
  }

  toNumberOrCurrent(value: number | string | undefined, currentValue: number | null | undefined): number {
    if (value === '' || value === null || value === undefined) {
      return currentValue ?? 0;
    }

    const convertedValue = Number(value);
    return Number.isNaN(convertedValue) ? (currentValue ?? 0) : convertedValue;
  }
  
}